export default "__VITE_ASSET__DK6vLuWO__"